import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import axios, { AxiosError, AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios';
import store from 'store';
import i18n from 'i18next';
import { eeEnvVariables } from './constants';
import { actionTriggers as notificationActionTriggers } from 'modules/popupNotification/stateManagement/actionsCreator';
import { acquireAccessToken } from './authorizationUtils';
import { _IS_MICRO_FRONTEND__ } from 'modules/auth/components/WebAppAuthProvider';
import { TokenResponse } from '@/modules/auth/hooks/useKeycloack';
export const TOKEN_FOR_DEVELOPMENT = sessionStorage.getItem('hm_auth_token') || '';
export const axiosClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

const shouldAvoidAuth =  _IS_MICRO_FRONTEND__ ? false : true;

const httpClient =
 !_IS_MICRO_FRONTEND__ 
    ? axiosClient
    : kf1AuthenticatedHttpClient;

const hideErrorNotificationAPI: string[] = [
  `${eeEnvVariables.API_URL}/employees/profile-image/me`,
  `${eeEnvVariables.API_URL}/career-progression/top-related-jobs/search`,
  `${eeEnvVariables.API_URL}/career-progression/recommendation-feedback`,
  `${eeEnvVariables.API_URL}/courses/search`,
  `${eeEnvVariables.API_URL}/assessments/upsertTellUsAboutYourself`,
];

const hideErrorNotificationPostAPI: string[] = [
  `${eeEnvVariables.API_URL}/learning-journey`,
];

async function axiosResponseErrorHandler(error: AxiosError) {
  const axiosRequest = error?.request;
  const axiosResponse = error?.response;
  const isAxiosResponseValid = (axiosRes: any) => axiosRes;
  //&& axiosRes?.status !== undefined && axiosRes?.status !== 401;
  const isAxiosRequestValid = (axiosReq: any) => axiosReq;

  if (
    isAxiosRequestValid(axiosRequest) &&
    isAxiosResponseValid(axiosResponse)
  ) {
    const errMsg = 'failToLoadFetchingCommonError';
    let silentAPI: string[] = [...hideErrorNotificationAPI];
    if (axiosResponse?.config?.method === 'post') {
      silentAPI.push(...hideErrorNotificationPostAPI);
    }
    const isHidingError = silentAPI.some((element) =>
      axiosRequest?.responseURL?.includes(element)
    );
    if (!isHidingError) {
      store.dispatch(
        notificationActionTriggers.popupNotificationEnqueued({
          severity: 'error',
          message: `${i18n.t(errMsg)}`,
        })
      );
    }
    return Promise.reject(error);
  }
}

async function generateFinalUrl(
  path: string,
  apiUrl?: string
): Promise<string> {
  const finalUrl: string = `${apiUrl || eeEnvVariables.API_URL}/${path}`;
  return finalUrl;
}

axiosClient?.interceptors.request.use(async (config) => {
    config.headers!.Authorization = `Bearer ${sessionStorage.getItem('hm_auth_token')}`;
  return config;
});


axiosClient?.interceptors.response.use(
  async (response: AxiosResponse) => {
    return response;
  },
 (error: AxiosError) => Promise.reject(error),
);

 

kf1AuthenticatedHttpClient?.interceptors.response.use(
  async (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => Promise.reject(error),
);

export async function axiosGet<R = unknown>(
  path: string,
  config?: AxiosRequestConfig | undefined,
  apiUrl?: string
): Promise<AxiosResponse<R>> {
  const finalUrl = await generateFinalUrl(path, apiUrl);
  const finalConfig = config ?? {};
  return httpClient.get(finalUrl, {
    ...finalConfig,
  });
}

export async function axiosPut<D = unknown, R = D>(
  path: string,
  data?: D,
  config?: AxiosRequestConfig | undefined,
  apiUrl?: string
): Promise<AxiosResponse<R>> {
  const finalUrl = await generateFinalUrl(path, apiUrl);
  const finalConfig = config ?? {};
  return httpClient.put(finalUrl, data, {
    ...finalConfig,
  });
}

export async function axiosPost<D = unknown, R = D>(
  path: string,
  data?: D,
  config?: AxiosRequestConfig | undefined,
  apiUrl?: string
): Promise<AxiosResponse<R>> {
  const finalUrl = await generateFinalUrl(path, apiUrl);
  const finalConfig = config ?? {};
  return httpClient.post(finalUrl, data, {
    ...finalConfig,
  });
}

export async function axiosPostFile<D = unknown, R = D>(
  path: string,
  data?: D,
  config?: AxiosRequestConfig | undefined,
  apiUrl?: string
): Promise<AxiosResponse<R>> {
  const finalUrl = await generateFinalUrl(path, apiUrl);
  const finalConfig = config ?? {};
  return httpClient.post(finalUrl, data, {
    ...finalConfig,
  });
}

export async function axiosDelete<R = unknown>(
  path: string,
  config?: AxiosRequestConfig | undefined,
  apiUrl?: string
): Promise<AxiosResponse<R>> {
  const finalUrl = await generateFinalUrl(path, apiUrl);
  const finalConfig = config ?? {};
  return httpClient.delete(finalUrl, {
    ...finalConfig,
  });
}
